import { HFlow, Icon, Text, Tooltip } from 'bold-ui'
import { RadioGroupField } from 'components/form'
import { TipoAgrupamentoRelatorioGerencialEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

export interface TipoAgrupamentoRadioGroupFieldProps {
  name: MetaPath<TipoAgrupamentoRelatorioGerencialEnum>
  hideChildren?: () => void
}

export function TipoAgrupamentoRadioGroupField(props: Readonly<TipoAgrupamentoRadioGroupFieldProps>) {
  const { name, hideChildren } = props

  const AGRUPAR_PESSOAS_TOOLTIP_TEXT =
    'Ao utilizar essa opção, os campos que permitem múltipla seleção serão agrupados na exibição dos dados e na geração da tabela, garantindo que cada cidadão seja contabilizado apenas uma vez.'
  const AGRUPAR_REGISTROS_TOOLTIP_TEXT =
    'Ao utilizar essa opção, os campos que permitem múltipla seleção serão exibidos de forma independente na exibição dos dados e na geração da tabela. O valor total não será exibido nesta visualização, pois a soma das categorias excederia o número real de cidadãos cadastrados.'

  return (
    <RadioGroupField
      name={name}
      label='Agrupar dados por'
      options={[
        {
          label: renderTipoAgrupamentoLabel('Pessoas', AGRUPAR_PESSOAS_TOOLTIP_TEXT),
          value: TipoAgrupamentoRelatorioGerencialEnum.PESSOAS,
        },
        {
          label: renderTipoAgrupamentoLabel('Registros', AGRUPAR_REGISTROS_TOOLTIP_TEXT),
          value: TipoAgrupamentoRelatorioGerencialEnum.REGISTROS,
        },
      ]}
      onChange={hideChildren}
    />
  )
}

const renderTipoAgrupamentoLabel = (label: string, tooltipText: string) => (
  <HFlow alignItems='center' hSpacing={0.5}>
    <Text>{label}</Text>
    <Tooltip text={tooltipText}>
      <Icon icon='infoCircleFilled' size={1} />
    </Tooltip>
  </HFlow>
)
